<template>
  <div class="s-form">
    <div class="s-form-head">
      <!--<a class="f-md bold s-form-opportunities p-cta" href="/pdf/current-opportunities.pdf" target="_blank" rel="noopener">Current Opportunities <span class="f-xs">- Requisition YL26</span></a>-->
      <h3 class="f-md bold">Send Us Your Information</h3>
    </div>
    <form class="s-form-container"
          @submit.prevent="submit"
          :style="{
        opacity: state === 'Sending...' ? 0.6 : 1,
        'pointer-events': state === '' ? 'auto' : 'none',
      }">

      <div class="s-form-rows">
        <div class="s-form-row">
          <div class="s-form-col">
            <label class="f-xs s-form-label">Name</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="text"
                   autocomplete="off"
                   name="firstname"
                   v-model="join.firstname"
                   required />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="f-xs s-form-label">Telephone</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="tel"
                   autocomplete="off"
                   name="telephone"
                   v-model="join.telephone"
                   required />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="f-xs s-form-label">Email</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="email"
                   autocomplete="off"
                   name="email"
                   v-model="join.email"
                   required />
          </div>
        </div>

        <div class="s-form-row file">
          <div class="s-form-col">
            <label class="f-xs s-form-label">Attach CV</label>
          </div>
          <div class="s-form-col">
            <div class="s-form-file-label"
                 @click="() => this.$el.querySelector('input[type=file]').click()">{{ fileName }}</div>
            <input class="f-md s-form-field field-file"
                   type="file"
                   autocomplete="off"
                   name="cv"
                   style="display: none"
                   @change="selectFile"
                   required />
          </div>
        </div>

        <div class="s-form-row s-form-row--textarea">
          <div class="s-form-col">
            <label class="f-xs s-form-label">Message</label>
          </div>
          <div class="s-form-col">
            <textarea class="f-md s-form-field"
                      type="text"
                      autocomplete="off"
                      name="description"
                      v-model="join.description"
                      rows="3"
                      maxlength="500"
                      required />
          </div>
        </div>
      </div>

      <div class="s-form-row recaptcha">
        <div class="s-recaptcha">
          <vue-recaptcha @verify="verify"
                         :loadRecaptchaScript="true"
                         :sitekey="'6LdvYqMZAAAAAAFYEJGWgZNJcheSW4niTUPD784F'" />
        </div>
      </div>

      <div class="s-form-bottom">
        <div class="s-form-col">
          <label class="s-form-label s-form-label--checkbox">
            Accept Terms & Disclaimers
            <input class="s-form-checkbox" type="checkbox" />
            <span class="s-form-checkmark p-cta"></span>
          </label>
        </div>
        <div class="s-form-col">
          <button class="f-xs s-form-send p-cta">{{ state === '' ? 'Send Information' : state }}</button>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
  import axios from 'axios';

  import VueRecaptcha from 'vue-recaptcha';
  import Form from './form';

  let form;

  export default {
    components: {
      VueRecaptcha,
    },
    mounted() {
      form = new Form();
      form.init();
    },
    destroyed() {
      form.destroy();
    },
    data() {
      return {
        path: document.location.href.indexOf('localhost') >= 0 ? 'http://dev.vrcapital.adorator.io/' : '/',
        fileName: 'No file selected',
        state: '',
        join: {
          verified: false,
          firstname: '',
          telephone: '',
          email: '',
          description: '',
          file: '',
        },
      };
    },
    methods: {
      verify() {
        this.join.verified = true;
      },
      selectFile() {
        const i = this.$el.querySelector('input[type=file]');
        this.fileName = i.files[0].name;
        this.join.file = i.files[0];
      },
      submit(evt) {
        if (!this.join.verified) return;
        evt.preventDefault();
        this.state = 'Sending...';
        const data = new FormData();
        data.append('name', this.join.firstname);
        data.append('telephone', this.join.telephone);
        data.append('email', this.join.email);
        data.append('description', this.join.description);
        data.append('cv', this.join.file);
        data.append('type', 'join');
        axios.post(`${this.path}post.php`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((response) => {
          console.log('Response:', JSON.stringify(response.data));
          if (response.data.error) {
            console.error('Server error:', response.data.message, response.data.debug);
            this.state = 'Error. Try again.';
            this.$el.querySelector('.s-form-send').style.color = '#fff';
            setTimeout(() => { this.state = ''; }, 4000);
            return;
          }
          this.state = 'Sent!';
          this.$el.querySelector('.s-form-send').style.color = '#fff';
          setTimeout(() => {
            this.state = '';
            this.join = {
              verified: false,
              firstname: '',
              telephone: '',
              email: '',
              description: '',
              file: '',
            };
            const i = this.$el.querySelector('input[type=file]');
            i.value = '';
            this.$el.querySelector('.s-form-file-label').innerHTML = '';
          }, 4000);
          console.log('success', response.data.message);
        }).catch((error) => {
          console.error('Request failed:', error);
          console.error('Response data:', error.response ? JSON.stringify(error.response.data) : 'No response');
          console.error('Status:', error.response ? error.response.status : 'No status');
          this.state = 'Error. Try again.';
          this.$el.querySelector('.s-form-send').style.color = '#fff';
          setTimeout(() => { this.state = ''; }, 4000);
        });
      },
    },
  };
</script>
